import React, { Component } from 'react';
import { connect } from 'react-redux';
//  Components
import Item from './item';

class CatalogViewGrid extends Component {
    render() {
        let arreglo = [];
        if (this.props.catalogo) {
            arreglo = this.props.catalogo.slice(
                (this.props.page - 1) * 12, 
                this.props.page * 12
            );
        }

        return (
            <div className="catalog-view-grid">
                <div className="row-responsive align-center justify-center">
                    <div className="catalog-cards-grid">
                        {arreglo.map((product, index) =>
                            <Item key={index} item={product} />
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        catalogo: state.catalogo_filtrado
    };
}

export default connect(mapStateToProps)(CatalogViewGrid);


// WEBPACK FOOTER //
// ./src/components/Products/catalog-view-grid.js